/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/utils/alert/loading.tsx
 * Papel: utilitario congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */


import { toast, ToastPosition, Zoom } from "react-toastify";

interface LoadingAlertParams {
    msg?: string;
    id?: string;
    autoClose?: number;
    position?: ToastPosition;
}

export function loadingAlertJSX({msg, id, autoClose, position}: LoadingAlertParams) {

    let new_msg = msg ?? 'Caregando...';
    let auto_destroy = autoClose ?? 30000;

    toast.loading(<div className="custom_toasty_loading">{msg}</div>, {
        position: position ?? "top-right",
        autoClose: auto_destroy ?? 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        //@ts-ignore
        transition: Zoom,
        className: 'gradient_toasty',
        toastId: id ?? 'loading_default',
        style: new_msg==='Caregando...' ? {width: 170} : undefined
    });

    setTimeout(() => {
        toast.dismiss(id ?? 'loading_default');
    }, auto_destroy);
    
};